
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/link/handle-invalid-link-token",
      function () {
        return require("private-next-pages/docs/link/handle-invalid-link-token.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/link/handle-invalid-link-token"])
      });
    }
  